export function createCartData(item, action, options = {}) {
  const id = item.productId || item.articule_id || item.id;
  const storeId = item.store_id;
  const quantity = item.quantity || item.qty;
  const basketId = item.basketId;
  const userPrice = item.userPrice;
  let formData = new FormData();

  formData.append("itemId", id);
  formData.append("store_id", storeId);
  formData.append("quantity", quantity);
  if (action === "updateUserPrice") formData.append("userPrice", userPrice);
  if (basketId) formData.append("basketId", basketId);
  formData.append("action", action);

  Object.keys(options).forEach(key => formData.append(key, options[key]));

  return formData;
}
